





import Clipboard from 'clipboard'
import { Vue, Component, Prop } from 'vue-property-decorator'
@Component({
  name: 'clipboard'
})
export default class extends Vue {
  @Prop({ required: true }) private text!: string

  handleCopy() {
    let clipboard = new Clipboard('.clipboard')
    clipboard.on('success', e => {
      console.log(1)
      this.$message.success('复制成功')
      clipboard.destroy()
    })
    clipboard.on('error', e => {
      console.log(0)
      clipboard.destroy()
    })
  }
}
